import * as _4 from 'lodash4';
import { APCourse } from '../../../../global/builders/ap_course_builder';
import { IAPCourseRequisite } from '../models/course_info_model';
import { ReqNode, ReqTree } from './course_req_tree';

export class ReqServant {
  static getReqTitle(reqNode: ReqNode, associatedCourses: Record<string, APCourse>) {
    if (reqNode.type === 'COURSE' || reqNode.type === 'GRADE') {
      const requisiteCourse = associatedCourses[reqNode.course];
      const rangeText = !!reqNode.range ? `required class grade not met (${reqNode.range})` : '';
      if (requisiteCourse) {
        // TODO: Check with Sravan for this
        // reqNode._course = requisiteCourse;
        reqNode.title = `<span class="text text-sz-s">${requisiteCourse.cd} ${requisiteCourse.title}</span> ${rangeText}`;
      }
    }
    if (ReqServant.isTestTypeRequisite(reqNode)) {
      const range = !!reqNode.range ? `(${reqNode.range})` : '';
      const displayTitle = !_4.isNil(reqNode.title) ? reqNode.title : reqNode.test;
      reqNode.title = `<span class="text text-sz-s">${displayTitle}</span> ${range}`;
    }
    return reqNode.title;
  }

  static isTestTypeRequisite(reqNode: ReqNode) {
    return reqNode.type === 'TEST';
  }

  static formChildrenReqList(reqNode: ReqNode, associatedCourses: Record<string, APCourse>) {
    const nonCompactedReqList = reqNode.childrens.map((child) => ReqServant.formReqList(child, associatedCourses));
    return _4.compact(nonCompactedReqList);
  }

  static formReqList(reqNode: ReqNode, associatedCourses: Record<string, APCourse>): string {
    if (_4.isEmpty(reqNode.childrens)) {
      const title = ReqServant.getReqTitle(reqNode, associatedCourses);
      if (_4.isEmpty(title)) {
        return ``;
      }
      return `<hi-leaf class="text text-sz-m pbsx">${title}</hi-leaf>`;
    } else {
      const reqList = ReqServant.formChildrenReqList(reqNode, associatedCourses);
      const hasOneEntry = reqList.length === 1;
      if (hasOneEntry) {
        return `<hi-leaf class="text text-sz-m pbsx">${reqList.join(' ')}</hi-leaf>`;
      }

      return `
          <hi-sub-tree heading="${ReqServant.getReqTitle(reqNode, associatedCourses)}">
          <hi-text slot="heading" allow-ellipsis>${ReqServant.getReqTitle(reqNode, associatedCourses)}</hi-text>
            ${reqList.join(' ')}
          </hi-sub-tree>`;
    }
  }

  static getReqTree(
    _requisites: Record<string, IAPCourseRequisite> | IAPCourseRequisite[],
    associatedCourses: Record<string, APCourse>
  ) {
    const requisites = _4.toArray(_requisites);
    const reqTree = new ReqTree();
    reqTree.insert(requisites[0]);

    let lastNode = reqTree.root;
    requisites.slice(1).forEach((req) => {
      lastNode = reqTree.insertData(req, lastNode as ReqNode);
      return lastNode;
    });

    return `
      <hi-tree>
        ${ReqServant.formReqList(reqTree.root as ReqNode, associatedCourses)}
      </hi-tree>
      `;
  }

  static openFirstLadderOfTree(tree: string) {
    const subTreeTagName = 'hi-sub-tree';
    const firstLadder = tree.search(subTreeTagName);
    const firstIndex = 0;
    if (firstLadder < firstIndex) {
      return tree;
    }
    const indexAfterSubtree = firstLadder + subTreeTagName.length;
    const untilSubTreeNodeText = tree.slice(firstIndex, indexAfterSubtree);
    const afterSubTreeNodeText = tree.slice(indexAfterSubtree);
    return (
      untilSubTreeNodeText + ` ap-add-attr-after="{'timeout': 500, 'attribute': 'opened'}" ` + afterSubTreeNodeText
    );
  }

  static getReqHtml(
    requisites: Record<string, IAPCourseRequisite> | IAPCourseRequisite[],
    associatedCourses: Record<string, APCourse>
  ) {
    const reqTree = ReqServant.getReqTree(requisites, associatedCourses);
    return ReqServant.openFirstLadderOfTree(reqTree);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_detail/servants/course_req_servant.ts